import Accessor from '@arcgis/core/core/Accessor';
import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { navbarRoute } from 'src/app/ui/NavBar/NavBarViewModel';

@subclass('Landing.data.QueryString.QueryStringViewModel')
export default class QueryStringViewModel extends Accessor {

  @property()
  portal: __esri.Portal;

  @property()
  defaultTab: navbarRoute;

  @property()
  defaultAppId: string;

  constructor(params?: any) {
    super(params);

    const urlParams = new URLSearchParams(window.location.search);

    this._handleTabs(urlParams);
    this._handleAppId(urlParams);

  }

  private _handleTabs(params: URLSearchParams) {
    let startTab: string = params.get("tab");
    
    if (startTab) {
      startTab = startTab.toLowerCase();
      // handle casing
      if (startTab === "browseall") { startTab = "browseAll"; }
      if (startTab === "myapps") { startTab = "myApps"; }

      // handle "create" into "browseall"
      if(startTab === "create"){ startTab = "browseAll"; }

      // ASSIGN A DEFAULT if input is junk 
      // NOTE! if navbarRoute changes, need to change this check
      if(!["browseAll", "create", "featured", "myApps"].includes(startTab)){
        startTab = "browseAll";
      }

      this.defaultTab = startTab as any;
    }
  }

  private _handleAppId(params: URLSearchParams) {
    const appId: string = params.get("appId");
    if (appId) {
      this.defaultAppId = appId;
    }
  }

}
